import Axios from "../../../../api/axios/Axios";

const channelPopsEndpoint = (username) =>
  `/api/creators/${encodeURIComponent(username)}/pops`;

export const getCreatorChannelPops = (username, params = {}) =>
  Axios.get(channelPopsEndpoint(username), {
    params,
  });

export const searchCreatorChannelPops = (username, searchValue, params = {}) =>
  Axios.get(`${channelPopsEndpoint(username)}/search`, {
    params: {
      ...params,
      searchValue,
    },
  });
